var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    { attrs: { "has-fixed-group": _vm.hasFixedGroup, nav: _vm.nav } },
    [
      _c(
        "div",
        {
          staticClass: "container-full",
          class: { small: _vm.small },
          attrs: { id: "inner-wrapper" },
        },
        [
          _vm._t("breadcrumbs"),
          _vm._v(" "),
          _vm._t("header"),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }